import { statusValue } from "constants/general";
import { has, mapValues } from "lodash";
import { ImportStatus } from "types/import";
import { capitalizeFirstLetter } from "utilities/strings";

export const getUnitsTransfersImportStatus = (
  status: ImportStatus,
  message: string,
) => {
  let errorMessage = "";
  if (typeof message === "object") {
    errorMessage = JSON.parse(message);
  }

  switch (true) {
    case status === statusValue.FAILED && has(errorMessage, "customerId"):
      return "memberDoesNotExist";
    case status === statusValue.FAILED:
    case status === statusValue.ERROR:
      return "failedToImport";
    case status === statusValue.SUCCEED:
      return "successfullyImported";
    case status === statusValue.IN_PROGRESS:
      return "inProgress";
    default:
      return "queued";
  }
};

export const getItemStatus = (status: string): string => {
  switch (status) {
    case statusValue.ERROR:
    case statusValue.FAILED:
      return "failedToImport";
    case statusValue.SUCCEED:
      return "successfullyImported";
    case statusValue.IN_PROGRESS:
      return "inProgress";
    default:
      return "queued";
  }
};

// temporary solution until better validation messages are implemented
// Function to safely parse a JSON string
export const tryParseJSONObject = (jsonString: string) => {
  try {
    const o = JSON.parse(jsonString);
    return o && typeof o === "object" ? o : false;
  } catch (e) {
    console.error("Invalid JSON:", e);
    return false;
  }
};

// Function to process and format the import message
export const parseImportMessage = (message: string) => {
  // Check if the message is a valid JSON
  const parsedMessage = tryParseJSONObject(message);
  if (!parsedMessage) {
    return message; // If not, return string
  }

  // Map the values in the message object
  const messageObject = mapValues(parsedMessage, (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => {
        return typeof item === "string"
          ? item
          : Object.entries(item).map(([key, value]) => `\n ${key}:${value}`);
      });
    }
    return value;
  });
  // Create a list of formatted messages
  const parsedMessages = Object.keys(messageObject).map((key) => {
    return `${capitalizeFirstLetter(key)}: ${messageObject[key]} \n`;
  });
  return parsedMessages.join("\n");
};
